import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function FailedAttemptsSection() {
  const attempts = [{
    emoji: '📚',
    title: 'Cambiaste la estrategia, pero no al actor',
    punchline: 'Mismo miedo + nueva táctica = mismo resultado.',
    desc: 'Compraste el curso de $997. Aprendiste los pasos. Pero los ejecutaste con la misma mentalidad de escasez y urgencia desesperada.'
  }, {
    emoji: '🪞',
    title: 'Pensamiento Positivo superficial',
    punchline: 'Perfume sobre un cubo de basura.',
    desc: 'Afirmaciones frente al espejo mientras por dentro sentías que te mentías. La verdad siempre sale a la superficie.'
  }, {
    emoji: '👥',
    title: 'Validación del entorno equivocado',
    punchline: 'Tus carceleros te dijeron que "el mundo es así".',
    desc: 'Hablaste de tus sueños con personas que ganan el salario mínimo. Su escepticismo alimentó tu punto ciego.'
  }, {
    emoji: '🥶',
    title: 'Disciplina física sin identidad',
    punchline: 'Sentencia de muerte por agotamiento.',
    desc: '5 AM + duchas frías + disciplina en el cuerpo, pero anarquía en el espíritu. Sin cambio de identidad = Burnout.'
  }, {
    emoji: '📡',
    title: 'Ignoraste el software maestro',
    punchline: 'El dinero es energía que se sintoniza adentro.',
    desc: 'Creíste que el dinero se "conseguía" afuera. No entendiste que primero cambia la frecuencia, luego cambia la cuenta.'
  }];
  return <section className="py-16 md:py-[80px] px-4" data-id="element-16">
      <div className="max-w-[900px] mx-auto" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-18">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-gold uppercase" data-id="element-19">
            <span className="inline-block h-[2px] w-5 bg-gold" data-id="element-20"></span>
            Por qué sigues atascado
          </div>
          <h2 className="font-heading text-3xl md:text-[40px] font-black leading-[1.1] text-white uppercase tracking-tight" data-id="element-21">
            LO QUE HAS INTENTADO... <br className="hidden md:block" data-id="element-22" />
            <span className="text-gold" data-id="element-23">Y POR QUÉ NO FUNCIONÓ</span>
          </h2>
        </motion.div>

        <motion.div className="flex flex-col gap-4" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-24">
          {attempts.map((attempt, index) => <motion.div key={index} variants={itemVariants} className="overflow-hidden rounded-lg border border-border bg-surface" data-id="element-25">
              <div className="flex items-center gap-3 px-[18px] py-[16px]" data-id="element-26">
                <div className="text-[22px]" data-id="element-27">{attempt.emoji}</div>
                <div className="flex-1 min-w-0" data-id="element-28">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-29">
                    <div className="font-heading text-[9px] font-bold tracking-[2px] text-gold uppercase" data-id="element-30">
                      Error #{index + 1}
                    </div>
                  </div>
                  <h3 className="font-heading text-[13px] font-black uppercase tracking-[0.5px] text-white" data-id="element-31">
                    {attempt.title}
                  </h3>
                </div>
                <div className="hidden md:block shrink-0 rounded-md border border-[#f44336]/20 bg-[#f44336]/5 px-3 py-1.5" data-id="element-32">
                  <span className="font-heading text-[10px] font-bold tracking-[0.5px] text-[#f44336] uppercase" data-id="element-33">
                    {attempt.punchline}
                  </span>
                </div>
              </div>
              <div className="border-t border-border px-[18px] py-[14px] text-[13px] leading-[1.7] text-text-card" data-id="element-34">
                {attempt.desc}
                <span className="md:hidden block mt-2 text-[11px] font-bold text-[#f44336] italic" data-id="element-35">
                  → {attempt.punchline}
                </span>
              </div>
            </motion.div>)}
        </motion.div>

        {/* Quote callout */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mt-8 rounded-lg border-2 border-gold/20 bg-gold/5 px-6 py-5 text-center" data-id="element-36">
          <p className="text-[15px] font-bold italic leading-[1.6] text-gold" data-id="element-37">
            "No puedes escuchar la estación 107.5 FM si tu radio está bloqueada
            en la 88.1 AM."
          </p>
        </motion.div>
      </div>
    </section>;
}